export const BOOKING = 'BOOKING';
export const RENTALCARS = 'RENTALCARS';
